<div id="particles-js"></div>
<div class="text">
  <h1 id="title">404</h1>
  <p id="subtitle">{{ "NOT_FOUND.SOMETHING_WENT_WRONG" | translate }}</p>
</div>
